var idioma = $('html').attr('lang');
$('.houdiniForm').each(function() {//per cada formulari
    'use strict';
    //validacio formulari
    $(this).validate({
        errorPlacement: function(error, element) {
            if (element.attr('type') === 'checkbox' || element.attr('type') === 'radio') {
                if (element.closest('div').find('input').length > 1) {
                    error.insertAfter(element.closest('div').find('p.type-label'));
                } else {
                    var label = element.nextAll("label").first();
                    error.insertAfter(label);
                }
            } else {
                error.insertAfter(element);
            }
        }
    });
    $(this).find('option[value="others_field"]').each(function(){
      var select = $(this).closest('select');
      var other = $(this).closest('.control').find('input[type="text"]');
      other.hide();
      select.on('change', function(){
          if (select.val() == 'others_field') {
            other.show();
          } else {
            other.hide().val('');
          }
      });
    });

    $(this).find('input[data-type="others_field"]').each(function(){
      var other = $(this).closest('ul').find('input[type="text"]')
      var inputs = $(this).closest('ul').find('input');
      other.hide();
      inputs.on('change', function(){
          if ($(this).closest('ul').find('input[data-type="others_field"]').is(":checked")){
            other.show();
            other.focus();
          }else{
            other.hide().val('');
          }
      });
    });
});

//datapicker

/*$('.houdiniForm .hasDatepicker').fdatepicker({
    language: idioma,
    format: "dd/mm/yyyy",
    weekStart: 1,
    leftArrow:
    '&lt;',
    rightArrow:
    '&gt;'
});*/

//chosen
$('.houdiniForm .chzn-select').select2();

$.fn.raty.defaults.path = '/media/img';
$.fn.raty.defaults.cancel = false;

//valoracio
$('.houdiniForm .scoreField').each(function() {
    'use strict';
    var field = $(this);
    var id = '#' + field.attr('id');
    var score = $('<div></div>');
    score.raty({
        half: true,
        hints: ['', '', '', '', ''],
        score: function() {
            return field.val();
        },
        targetScore: id
    });
    field.hide();
    field.after(score);
});

//select de dnis
$('.houdiniForm .dninifnie').each(function() {
    'use strict';
    $(this).find('select').on('change', function() {
        var value = $(this).val();
        var input = $(this).closest('div.row').find('input');

        if (value === 'DNI') {
            input.rules('add', {
                dni: true,
                cifES: false,
                nieES: false
            });
        } else if (value === 'NIF') {
            input.rules('add', {
                dni: false,
                cifES: true,
                nieES: false
            });
        } else if (value === 'NIE') {
            input.rules('add', {
                dni: false,
                cifES: false,
                nieES: true
            });
        }
    });
});
